import { post, del } from './http';

// 获取产品列表
export const getProductList = (p: any) => post('product/findList', p);

// 获取点击排行
export const getRankList = (p: any) => post('policyInfo/showByClickcount', p);

// 获取需求分类
export const getRequireTypes = (p: any) => post('organizationtype/findByFatherId', p);

// 获取机构列表
export const getOrganizationList = (p: any) => post('organization/findList', p);

// 获取知识列表
export const getKnowledgeList = (p: any) => post('knowledge/findList', p);

// 搜索需求
export const searchRequire = (p: any) => post('SearchRequire/search', p);

// 新闻列表
export const getNewsList = () => post('policyInfo/findLatestNews');

// 行业列表
export const getIndustryList = (p: any) => post('trade/findByFatherId', p);

// 全部区域列表
export const getLocationList = (p: any) => post('Location/AllLocation', p);

// 机构搜索
export const searchOrganization = (p: any) => post('SearchOrganization/search', p);

// 知识分类
export const getKnowledgeType = (p: any) => post('knowledgetype/findByFatherId', p);

// 获取机构详情
export const getOrgDetail = (p: any) => post('organization/findById', p);

// 获取需求详情
export const getRequireDetail = (p: any) => post('require/findById', p);

// 获取产品详情
export const getProductDetail = (p: any) => post('product/findById', p);

// 获取知识详情
export const getKnowledgeDetail = (p: any) => post('knowledge/findById', p);

// 密码登录
export const loginByPassword = (p: any) => post('login/userLogin', p);

// 手机号登录
export const loginByPhone = (p: any) => post('login/userLoginByPhone', p);

// 获取登录用户信息
export const getLoginUser = () => post('login/getLoginUser');

// 注销登录
export const logout = () => post('login/logout');

// 手机号找回密码
export const updatePasswordByPhone = (p: any) => post('user/updatepasswordByPhone', p);

// 获取验证码
export const getValidateCode = (p: any) => post('verificationCode/singleSendercode', p);

// 校验验证码
export const validateCode = (p: any) => post('verificationCode/judgecode', p);

// 注册账号
export const registerAccount = (p: any) => post('user/addUser', p);

export const getDistrictList = (p: any) => post('Location/location', p);

export const getGarden = (p: any) => post('Garden/getByLocation', p);

export const getAllIndustry = () => post('industry/findAllIndustry');

export const getUserAccountDetail = () => post('user/showDetail');

// 更改基础信息
export const updateBasicInfo = (p: any) => post('user/updateInfoBasic', p);

// 身份认证
export const submitAuth = (p: any) => post('IdCard/ShenfenRenzheng', p);

// 获取邮箱验证码
export const getEmailValidateCode = (p: any) => post('mail/sendCode', p);

// 更新邮箱
export const updateMail = (p: any) => post('user/updatemailAddress', p);

// 更新手机号
export const updatePhone = (p: any) => post('user/updatemobilePhone', p);

// 修改密码
export const updatePassword = (p: any) => post('user/updatepassword', p);

// 验证企业名称是否重复
export const judgeDuplicateEnterpriseName = (p: any) => post('enterprise/judgeEnterpriseName', p);

// 获取企业详情
export const getEnterpriseDetail = () => post('enterprise/showDetailInfo');

// 新增企业
export const addEnterprise = (p: any) => post('enterprise/add', p);

// 修改企业
export const updateEnterprise = (p: any) => post('enterprise/update', p);

// 获取营业执照列表
export const getBusinessLicenseList = () => post('BusinessLicense/show');

// 获取资质证书列表
export const getQualificationList = () => post('Zizhicertificate/showlist');

// 删除资质证书
export const delQualification = (id: string) => del(`Zizhicertificate/delete?id=${id}`);

// 删除获奖证书
export const delHonor = (id: string) => del(`Huojiangcertificate/delete?id=${id}`);

// 获取获奖证书列表
export const getHonorList = () => post('Huojiangcertificate/showlist');

// 删除消息
export const deleteMessage = (id: string) => del(`message/delete?id=${id}`);

// 修改消息状态
export const updateMessageStatus = (p: any) => post('message/updateReadLot', p);

// 获取机构详情
export const getLoginOrg = () => post('organization/showDetailInfo');

// 提交机构属性
export const submitOrg = (p: any) => post('organization/addAndUpdateOrganization', p);

// 机构收藏
export const addOrgFavorite = (id: string) => post('orgfavorite/addFavorite', { organizationid: id });

// 删除机构收藏
export const delOrgFavorite = (id: string) => del(`orgfavorite/deleteFavorite?organizationid=${id}`);

// 产品收藏
export const addProductFavorite = (id: string) => post('proFavorite/addFavorite', { productid: id });

// 删除产品收藏
export const delProductFavorite = (id: string) => del(`proFavorite/deleteFavorite?productid=${id}`);

// 需求收藏
export const addRequireFavorite = (id: string) => post('requireFavorite/addFavorite', { requirementid: id });

// 删除需求收藏
export const delRequireFavorite = (id: string) => del(`requireFavorite/deleteFavorite?requirementid=${id}`);

// 知识收藏
export const addKnowFavorite = (id: string) => post('knowFavorite/addFavorite', { knowledgeid: id });

// 删除知识收藏
export const delKnowFavorite = (id: string) => del(`knowFavorite/deleteFavorite?knowledgeid=${id}`);

// 添加产品
export const addProduct = (p: any) => post('product/add', p);

// 删除产品
export const delProduct = (id: string) => del(`product/delete?id=${id}`);

// 修改产品
export const updateProduct = (p: any) => post('product/update', p);

// 添加需求
export const addRequire = (p: any) => post('require/add', p);

// 删除/上架/下架需求
export const delRequire = (id: string, flag = '1') => del(`require/delete?id=${id}&delFlag=${flag}`);

// 修改需求
export const updateRequire = (p: any) => post('require/update', p);

// 获取验证图片
export const getValidatePicture = `${process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : '/'}verificationCode/generate?`;

// 验证图片验证码
export const validateImgCode = (p: any) => post('verificationCode/judgenumber', p);

// 提交反馈
export const submitFeedback = (p: any) => post('Feedback/add', p);
